// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3e13ec73","455":"f33edccc","977":"beccfff5"}[chunkId] + ".chunk.js";
};